/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'src/hooks';
import Storage from 'src/utils/storage/storage';
import { Grid, Typography } from '@mui/material';
import { PbiIframe } from 'src/components/analytics';
import { getRecentlyOpenedPayload } from 'src/components/layout/appDrawer/utils';
import useMatomoFunction from 'src/hooks/use-matomo-function.hook';
import { MatomoEventTrackMapObject } from '../../analytics/simulator/constants/constant';
import {
  recordRecentOpenReport,
  setActiveBottomTab
} from '../landing/store/landing-slice';

export default function PowerBIEmbedContainer({
  component,
  routesMetaDataPBI,
  fromClusterSummary = false
}: {
  component: { pbiEmbedUrl: string };
  routesMetaDataPBI?: any;
  fromClusterSummary?: boolean;
}) {
  const location = useLocation();
  const appDispatch = useAppDispatch();
  const { callFunction } = useMatomoFunction();

  // getting the source id from storage
  const { source: sourceId } = Storage.getSourceId();
  const trackRecentPBIPayload =
    routesMetaDataPBI.parent.is_pb_page &&
    getRecentlyOpenedPayload(routesMetaDataPBI.parent);
  const pageTitle = routesMetaDataPBI?.parent?.route_url || 'Power BI Embed Page';
  useEffect(() => {
    if (!fromClusterSummary && trackRecentPBIPayload && sourceId) {
      appDispatch(
        recordRecentOpenReport({ ...trackRecentPBIPayload, sourceID: sourceId })
      );
      // reset the activeBottomTab (if any popup is opened on homepage initially)
      appDispatch(setActiveBottomTab(''));
    }
  }, [trackRecentPBIPayload, sourceId]);
  const getPageName = () => {
    const page_title = window.location.href.split('/').at(-1);
    return page_title;
  };
  const pageName = getPageName()
  useEffect(() => {
    if (!fromClusterSummary) {
      callFunction(
        MatomoEventTrackMapObject.track_page_view.event_key,
        pageName
      );
    }

  }, [pageName]);
  useEffect(() => {
    if (!fromClusterSummary) {
      callFunction('track_user_details')
    }
    // callFunction('track_page_view', pageTitle)
  }, [])

  if (fromClusterSummary) {
    const params = new URLSearchParams(location.search);
    const pbiUrl = params.get('pbiUrl');
    // Only render the iframe, skip all tracking and API calls
    if (!pbiUrl) {
      return (
        <Grid container sx={{ p: (theme) => theme.spacing(1) }}>
          <Grid item xs={12}>
            <Typography variant='h5'>
              Power BI Embed URL not found or props not passed
            </Typography>
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid container sx={{ p: (theme) => theme.spacing(1) }}>
        <Grid item xs={12}>
          <PbiIframe pbiUrl={pbiUrl} />
        </Grid>
      </Grid>
    );
  }

  if (!component || !component.pbiEmbedUrl) {
    console.error('Power BI Embed url not found', component);
    return (
      <Grid container sx={{ p: (theme) => theme.spacing(1) }}>
        <Grid item xs={12}>
          <Typography variant='h5'>
            {' '}
            Power BI Embed URL not found or props not passed{' '}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container sx={{ p: (theme) => theme.spacing(1) }}>
      <Grid item xs={12}>
        <PbiIframe pbiUrl={component.pbiEmbedUrl} />
      </Grid>
    </Grid>
  );
}
